import React, { Fragment, useEffect, useState } from 'react';
import HistoryTab from '../surge-tabs/history';
import { PolygonSurgeTabProps } from '../surge-tabs/types';
import { Paginate } from '@cokitchen/cokitchen-components';
import { ALL_POLYGONS_ID } from 'utils/constants';
import { apiService } from 'utils/api';

const baseUrl = process.env.REACT_APP_ORDER_STATS_API_KEY;
const DeliverySettingsHistory: React.FC<PolygonSurgeTabProps> = ({ cokitchen_polygon_id }) => {
  const [loading, setLoading] = useState(false);
  const [historyList, setHistoryList] = useState([]);
  const [pageCount, setPageCount] = useState<number>(1);

  const fetchDeliverySettingsHistory = async (pageNo = 1) => {
    setLoading(true);
    try {
      let res = null;
      if (cokitchen_polygon_id === ALL_POLYGONS_ID) {
        res = await apiService.post(`logistics/delivery-settings/general/instant/get/${pageNo}`, {
          baseUrl
        });
      } else {
        res = await apiService.post(`logistics/delivery-settings/polygon/instant/get/${pageNo}`, {
          data: { cokitchen_polygon_id },
          baseUrl
        });
      }
      const response = res?.data?.data;
      setHistoryList(response);
      setPageCount(Math.ceil(+res?.data?.total / 10));
    } finally {
      setLoading(false);
    }
  };
  const getSelectedPageData = async (val: { selected: number }) => {
    const pageNo = val?.selected + 1;
    await fetchDeliverySettingsHistory(pageNo);
  };

  useEffect(() => {
    fetchDeliverySettingsHistory();
  }, [cokitchen_polygon_id]);

  return (
    <Fragment>
      <HistoryTab color='green' loading={loading} historyList={historyList} />
      {!loading && <Paginate pageCount={pageCount} onPageChange={getSelectedPageData} />}
    </Fragment>
  );
};

export default DeliverySettingsHistory;
